export const Flag = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 16 16"
      shape-rendering="crispEdges"
    >
      <metadata>
        Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj
      </metadata>
      <path
        stroke="#8e051c"
        d="M0 0h4M0 1h1M0 2h1M0 3h1M9 3h1M0 4h1M7 4h2M0 5h1M8 5h1M12 5h1M0 6h1M8 6h1M0 7h1M9 7h1M0 8h1M9 8h1M0 9h1M8 9h1M0 10h1M0 11h1M0 12h1M0 13h1M0 14h1M0 15h7"
      />
      <path
        stroke="#c10119"
        d="M4 0h4M15 0h1M10 2h1M5 3h1M6 4h1M9 4h1M12 4h1M6 5h2M9 5h1M6 6h2M9 6h2M7 7h2M10 7h1M5 8h1M7 8h2M6 9h2M7 15h4M15 15h1"
      />
      <path
        stroke="#ff0000"
        d="M8 0h7M15 1h1M11 2h1M15 2h1M10 3h1M12 3h1M15 3h1M5 4h1M10 4h2M15 4h1M5 5h1M10 5h2M15 5h1M5 6h1M15 6h1M5 7h2M15 7h1M6 8h1M15 8h1M15 9h1M15 10h1M15 11h1M15 12h1M15 13h1M15 14h1M11 15h4"
      />
      <path
        stroke="#222428"
        d="M1 1h1M6 1h9M14 2h1M4 3h1M14 3h1M4 4h1M14 4h1M4 5h1M14 5h1M4 6h1M14 6h1M4 7h1M14 7h1M4 8h1M14 8h1M4 9h1M14 9h1M4 10h1M3 12h3M4 13h1M14 14h1"
      />
      <path
        stroke="#333436"
        d="M2 1h4M1 2h1M3 3h1M3 4h1M3 5h1M3 6h1M3 7h1M3 8h1M3 9h1M5 9h1M3 10h1M5 10h3M14 10h1M3 11h1M5 11h1M14 11h1M2 12h1M14 12h1M1 13h1M14 13h1M1 14h5M13 14h1"
      />
      <path
        stroke="#4b4c4e"
        d="M2 2h2M5 2h5M12 2h2M1 3h2M6 3h3M13 3h1M1 4h2M13 4h1M1 5h2M13 5h1M1 6h2M11 6h3M1 7h2M11 7h3M1 8h2M10 8h4M1 9h2M9 9h5M1 10h2M8 10h6M1 11h2M6 11h8M1 12h1M6 12h8M7 13h7M6 14h7"
      />
      <path stroke="#16181e" d="M4 2h1M3 13h1M5 13h1" />
      <path stroke="#ffffff" d="M11 3h1" />
      <path stroke="#000000" d="M4 11h1M2 13h1M6 13h1" />
    </svg>
  );
};
